import React from "react";
const ResultPage = () => {
    return (
        <div>
            <ul>
                Activity Result Page
            </ul>
        </div>
    );
};

export default ResultPage;